<template>
    <div class="col-2">

        <div>
            <div class="d-flex mt-2">

                <div class="p-1 me-auto">
                    <h5>Tabs</h5>
                </div>

                <div class="dropdown">
                    <button class="btn btn-sm btn-primary me-2 dropdown-toggle" type="button"
                            id="newTabDropdownButton" data-bs-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        <i class="fal fa-plus text-white"></i>
                    </button>

                    <div class="dropdown-menu" style="width: 250px;">
                        <new-tab-form></new-tab-form>
                    </div>
                </div>

            </div>

            <tab-display v-for="(tab, index) in model.app.nav.tabs" :tab="tab" :index="index" :key="index + 'Tab'"
                         @removeTabClick="onRemoveTabClick" :current-view="view"></tab-display>

        </div>

<!--        <nav-editor :app="model.app" :tabs="model.app.nav.tabs"></nav-editor>-->
    </div>
</template>

<script>
    import NavEditor from "../app/NavEditor.vue";
    import TabDisplay from "./TabDisplay.vue";
    import NewTabForm from "../app/NewTabForm.vue";
    import AppService from "../../services/AppService";
    export default {
        name: 'AppConfig',
        components: {NewTabForm, TabDisplay, NavEditor},
        props: ['view', 'prop2'],
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            onRemoveTabClick (index) {
                this.model.app.nav.tabs.splice(index, 1)
                let service = new AppService()
                let request = {
                    app: this.model.app
                }

                service.update(this.model.app.id, request)
            },
        }
    }
</script>

<style>

</style>
